import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import routes from "Router";

import "./index.css";
import "./../src/assets/Custom.css"
import createStore from "store";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import NetworkProvider from "context/NetworkProvider";
import NetworkGate from "components/NetworkGate";
import { BrandingProvider } from "context/BrandingProvider";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "queryClient";

const root = ReactDOM.createRoot(document.getElementById("root"));
const { persistor, store } = createStore();
root.render(
  <React.StrictMode>
  <NetworkProvider>
    <NetworkGate>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <BrandingProvider>
            <RouterProvider router={routes} />
            <ToastContainer
              position="top-right"
              autoClose={2000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick={false}
              rtl={false}
              draggable
              pauseOnHover
              theme="light"
            />
          </BrandingProvider>
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    </NetworkGate>
  </NetworkProvider>
  </React.StrictMode>
);
